import { render } from "./Section.vue?vue&type=template&id=05649280"
import script from "./Section.vue?vue&type=script&lang=js"
export * from "./Section.vue?vue&type=script&lang=js"

import "./Section.vue?vue&type=style&index=0&id=05649280&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__